import { t } from "@i18n";

/** RFC 9457 problem document returned by the backend; ``code`` is stable and English, the UI translates it. */
export type Problem = {
  code: string;
  status: number;
  detail?: string;
  request_id?: string | null;
  cells?: { row_id: number; column: string; actual?: unknown; message?: string }[];
  errors?: { loc: (string | number)[]; msg: string }[];
};

export class ApiError extends Error {
  readonly problem: Problem;
  readonly status: number;

  constructor(problem: Problem, status: number) {
    super(problem.detail ?? problem.code);
    this.name = "ApiError";
    this.problem = problem;
    this.status = status;
  }

  get code(): string {
    return this.problem.code;
  }
}

/** A message in the UI language for any error (the problem's own fields, e.g. the value refused, fill its
 *  placeholders); the request id lets the operators find the English log line (a refused request's is
 *  ``request_invalid``: which fields and why). */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const text = t(`errors.${error.code}`, { replace: error.problem, defaultValue: t("errors.unexpected") });
    return error.problem.request_id ? `${text} (${t("errors.errorId")}: ${error.problem.request_id})` : text;
  }
  return t("errors.network");
}
